import { tokenService } from './token-service'
import { browserUtil } from '../util/browser-util'

export const authService = {
  logout: async (): Promise<void> => {
    await tokenService.clear()
    browserUtil.redirect('/auth/get-in')
  },
}
